<template>
  <PresentSelector
    :options="options"
    :present-missing="presentMissing"
    :present-line="presentLine"
    :present-line-missing-layer="presentLineMissingLayer"
    :present-line-divided="presentLineDivided"

    @changePresent="changePresent"
  />
</template>

<script>
import PresentSelector from '@/components/web/common/PresentSelector'

export default {
  name: 'LotteryPresentSelector',
  components: { PresentSelector },
  props: {
    componentName: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      options: ['presentMissing', 'presentLine', 'presentLineMissingLayer', 'presentLineDivided'],

      presentMissing: true,
      presentLine: true,
      presentLineMissingLayer: false,
      presentLineDivided: false
    }
  },
  created() {
    const { componentName } = this

    switch (componentName) {
      case 'WebHaoMaFenBu':
        this.options = ['presentMissing', 'presentLineMissingLayer', 'presentLineDivided']
        break
      // 切換options 或其他present 項目的預設值
      default:
    }
  },
  methods: {
    changePresent(event) {
      this.$emit('changePresent', event)
    }
  }
}
</script>
